function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M856.57,340.07l32.35-148.77h78.03l-3.64,18.83H906.4l-9.36,43.49h52.43l-4.06,18.73h-52.43l-14.67,67.73 H856.57z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M964.97,294.29c0-18.86,5.37-34.3,16.13-46.3c11.3-12.76,26.6-19.14,45.88-19.14c14.7,0,26.41,4.21,35.11,12.64 c8.7,8.43,13.06,20.06,13.06,34.9c0,19.07-5.24,34.71-15.71,46.92c-11.1,12.9-26.11,19.35-45.05,19.35 c-15.26,0-27.22-4.06-35.89-12.17C969.48,322.03,964.97,309.97,964.97,294.29z M986.3,295.75c0,9.09,2.29,16.37,6.87,21.85 c4.92,5.9,11.93,8.84,21.02,8.84c10.96,0,20.39-5.27,28.3-15.81c7.56-10.13,11.34-21.54,11.34-34.23c0-8.67-2.36-15.92-7.07-21.74 c-5.13-6.38-12-9.57-20.6-9.57c-12.35,0-22.3,5.62-29.86,16.85C989.63,271.79,986.3,283.06,986.3,295.75z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M1092.62,340.07l18.93-92.07c0.69-3.4,1.7-8.91,3.02-16.54h18.73l-3.43,17.17h0.42 c8.25-13.18,20.63-19.77,37.14-19.77c2.77,0,5.83,0.62,9.16,1.87l-4.47,17.69c-3.68-1.39-6.52-2.08-8.53-2.08 c-10.96,0-20.32,5.03-28.09,15.09c-5.76,7.49-9.61,15.88-11.55,25.18l-11.34,53.47H1092.62z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M1229.72,247.58l3.02-16.13h24.24l5.31-25.18l21.54-7.49l-6.76,32.67h29.75l-3.12,16.13h-30.07l-9.99,46.71 c-2.15,9.92-3.22,16.72-3.22,20.39c0,7.84,4.82,11.76,14.46,11.76c5.2,0,9.88-0.94,14.04-2.81l-2.91,16.65 c-4.16,1.59-10.71,2.39-19.66,2.39c-8.74,0-15.43-2.6-20.08-7.8c-3.95-4.3-5.93-9.74-5.93-16.33c0-4.65,1.28-13.18,3.85-25.59 l9.36-45.36H1229.72z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M1307.33,340.07l33.39-159.8h20.08l-13.42,64.81h0.42c7.42-10.82,18.86-16.23,34.33-16.23 c10.96,0,19.63,2.81,26.01,8.43c6.8,5.97,10.2,14.53,10.2,25.7c0,4.99-0.87,11.58-2.6,19.77l-11.96,57.32h-19.97l13.42-65.02 c0.69-3.4,1.04-6.8,1.04-10.2c0-5.76-1.79-10.49-5.36-14.2c-3.57-3.71-8.38-5.57-14.41-5.57c-10.96,0-20.32,5.03-28.09,15.08 c-5.76,7.49-9.61,15.88-11.55,25.18l-11.55,54.72H1307.33z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M1523.49,319.78l-3.22,18.41c-12.21,2.98-22.92,4.47-32.15,4.47c-33.43,0-50.14-16.33-50.14-49 c0-16.51,5.13-31.07,15.4-43.69c11.37-14.08,26.08-21.12,44.11-21.12c12.97,0,23.03,3.68,30.17,11.03 c7.14,7.35,10.71,17.51,10.71,30.48c0,5.55-0.66,12.17-1.98,19.87h-76.47c-0.42,2.36-0.62,4.61-0.62,6.76 c0,19.63,11.17,29.44,33.5,29.44C1502.58,326.44,1512.81,324.22,1523.49,319.78z M1462.11,275.25h55.56 c0.42-3.19,0.62-5.93,0.62-8.22c0-6.66-1.94-11.93-5.83-15.81c-4.09-4.09-9.82-6.14-17.17-6.14c-7.84,0-14.88,3.02-21.12,9.05 C1468.35,259.82,1464.33,266.86,1462.11,275.25z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M855.94,550.77l18.93-92.07c0.69-3.4,1.7-8.91,3.02-16.54h18.73l-3.43,17.17h0.42 c8.25-13.18,20.63-19.77,37.14-19.77c2.77,0,5.83,0.62,9.15,1.87l-4.47,17.69c-3.68-1.39-6.52-2.08-8.53-2.08 c-10.96,0-20.32,5.03-28.09,15.08c-5.76,7.49-9.61,15.88-11.55,25.18l-11.34,53.47H855.94z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M939.36,505c0-18.86,5.37-34.3,16.13-46.3c11.3-12.76,26.6-19.14,45.88-19.14c14.7,0,26.41,4.21,35.11,12.64 c8.7,8.43,13.06,20.06,13.06,34.9c0,19.07-5.24,34.71-15.71,46.92c-11.1,12.9-26.11,19.35-45.05,19.35 c-15.26,0-27.22-4.06-35.89-12.17C943.87,532.74,939.36,520.67,939.36,505z M960.68,506.45c0,9.09,2.29,16.37,6.87,21.85 c4.92,5.9,11.93,8.84,21.02,8.84c10.96,0,20.39-5.27,28.3-15.81c7.56-10.13,11.34-21.54,11.34-34.23c0-8.67-2.36-15.92-7.07-21.74 c-5.13-6.38-12-9.57-20.6-9.57c-12.35,0-22.3,5.62-29.86,16.85C964.01,482.49,960.68,493.76,960.68,506.45z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M1088.77,464.94l3.64-19.87c11.1-3.68,21.19-5.51,30.27-5.51c12.34,0,22.26,2.5,29.75,7.49 c8.81,5.97,13.21,14.98,13.21,27.05c0,4.99-0.62,10.68-1.87,17.06c-2.84,13.46-6.62,33.33-11.34,59.61h-18.52l3.64-18.1h-0.42 c-3.33,6.38-8.22,11.43-14.67,15.14c-6.45,3.71-13.35,5.57-20.7,5.57c-9.85,0-17.93-2.46-24.24-7.39 c-7.01-5.41-10.51-12.97-10.51-22.68c0-26.42,21.47-39.64,64.4-39.64c-0.14,0,4.68,0.21,14.46,0.62c0.69-3.54,1.04-5.89,1.04-7.07 c0-14.29-8.29-21.43-24.86-21.43C1110.14,455.79,1099.04,458.84,1088.77,464.94z M1141.62,498.55h-15.29 c-9.92,0-18.14,1.53-24.66,4.58c-8.88,4.02-13.32,10.47-13.32,19.35c0,4.58,1.8,8.22,5.41,10.92c3.26,2.5,7.42,3.75,12.48,3.75 c9.5,0,17.65-4.13,24.45-12.38C1136.67,517.41,1140.31,508.67,1141.62,498.55z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M1311.99,390.97l-26.84,123.8c-2.64,12.14-4.72,24.14-6.24,36h-18.73c0.62-3.67,1.84-9.22,3.64-16.65h-0.42 c-6.59,12.83-18.97,19.25-37.14,19.25c-12.55,0-22.54-4.51-29.96-13.53c-6.87-8.46-10.3-19.18-10.3-32.15 c0-18.38,4.75-33.98,14.25-46.82c10.47-14.22,24.48-21.33,42.03-21.33c17.27,0,28.92,6.83,34.96,20.49h0.42l14.25-69.08H1311.99z  M1207.33,506.25c0,9.15,2.12,16.47,6.35,21.95c4.65,5.97,11.34,8.95,20.08,8.95c11.44,0,20.7-6.07,27.78-18.21 c5.89-10.26,8.84-21.46,8.84-33.6c0-8.46-2.32-15.4-6.97-20.81c-4.93-5.83-11.62-8.74-20.08-8.74c-10.89,0-19.84,5.86-26.84,17.58 C1210.38,483.5,1207.33,494.46,1207.33,506.25z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M1390.65,464.94l3.64-19.87c11.1-3.68,21.19-5.51,30.27-5.51c12.34,0,22.26,2.5,29.75,7.49 c8.81,5.97,13.21,14.98,13.21,27.05c0,4.99-0.62,10.68-1.87,17.06c-2.84,13.46-6.62,33.33-11.34,59.61h-18.52l3.64-18.1h-0.42 c-3.33,6.38-8.22,11.43-14.67,15.14c-6.45,3.71-13.35,5.57-20.7,5.57c-9.85,0-17.93-2.46-24.24-7.39 c-7.01-5.41-10.51-12.97-10.51-22.68c0-26.42,21.46-39.64,64.4-39.64c-0.14,0,4.68,0.21,14.46,0.62c0.69-3.54,1.04-5.89,1.04-7.07 c0-14.29-8.29-21.43-24.86-21.43C1412.01,455.79,1400.92,458.84,1390.65,464.94z M1443.5,498.55h-15.29 c-9.92,0-18.14,1.53-24.66,4.58c-8.88,4.02-13.32,10.47-13.32,19.35c0,4.58,1.8,8.22,5.41,10.92c3.26,2.5,7.42,3.75,12.48,3.75 c9.5,0,17.65-4.13,24.45-12.38C1438.54,517.41,1442.18,508.67,1443.5,498.55z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M1481.38,550.77l33.4-159.8h20.08l-13.42,64.81h0.42c7.42-10.82,18.86-16.23,34.33-16.23 c10.96,0,19.63,2.81,26.01,8.43c6.8,5.97,10.2,14.53,10.2,25.7c0,4.99-0.87,11.58-2.6,19.77l-11.96,57.32h-19.97l13.42-65.02 c0.69-3.4,1.04-6.8,1.04-10.2c0-5.76-1.79-10.49-5.36-14.2c-3.57-3.71-8.38-5.57-14.41-5.57c-10.96,0-20.32,5.03-28.09,15.08 c-5.76,7.49-9.61,15.88-11.55,25.18l-11.55,54.72H1481.38z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M1696.54,530.49l-3.22,18.41c-12.21,2.98-22.92,4.47-32.15,4.47c-33.43,0-50.14-16.33-50.14-49 c0-16.51,5.13-31.07,15.4-43.69c11.37-14.08,26.08-21.12,44.11-21.12c12.97,0,23.03,3.68,30.17,11.03 c7.14,7.35,10.71,17.51,10.71,30.48c0,5.55-0.66,12.17-1.98,19.87h-76.47c-0.42,2.36-0.62,4.61-0.62,6.76 c0,19.63,11.17,29.44,33.5,29.44C1675.63,537.14,1685.86,534.92,1696.54,530.49z M1635.16,485.96h55.56 c0.42-3.19,0.62-5.93,0.62-8.22c0-6.66-1.94-11.93-5.83-15.81c-4.09-4.09-9.82-6.14-17.17-6.14c-7.84,0-14.88,3.02-21.12,9.05 C1641.4,470.53,1637.38,477.57,1635.16,485.96z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M1746.79,464.94l3.64-19.87c11.1-3.68,21.19-5.51,30.27-5.51c12.34,0,22.26,2.5,29.75,7.49 c8.81,5.97,13.21,14.98,13.21,27.05c0,4.99-0.62,10.68-1.87,17.06c-2.84,13.46-6.62,33.33-11.34,59.61h-18.52l3.64-18.1h-0.42 c-3.33,6.38-8.22,11.43-14.67,15.14c-6.45,3.71-13.35,5.57-20.7,5.57c-9.85,0-17.93-2.46-24.24-7.39 c-7.01-5.41-10.51-12.97-10.51-22.68c0-26.42,21.47-39.64,64.4-39.64c-0.14,0,4.68,0.21,14.46,0.62c0.69-3.54,1.04-5.89,1.04-7.07 c0-14.29-8.29-21.43-24.86-21.43C1768.15,455.79,1757.05,458.84,1746.79,464.94z M1799.64,498.55h-15.29 c-9.92,0-18.14,1.53-24.66,4.58c-8.88,4.02-13.32,10.47-13.32,19.35c0,4.58,1.8,8.22,5.41,10.92c3.26,2.5,7.42,3.75,12.48,3.75 c9.5,0,17.65-4.13,24.45-12.38C1794.68,517.41,1798.32,508.67,1799.64,498.55z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M1969,390.97l-26.84,123.8c-2.64,12.14-4.72,24.14-6.24,36h-18.73c0.62-3.67,1.84-9.22,3.64-16.65h-0.42 c-6.59,12.83-18.97,19.25-37.14,19.25c-12.55,0-22.54-4.51-29.96-13.53c-6.87-8.46-10.3-19.18-10.3-32.15 c0-18.38,4.75-33.98,14.25-46.82c10.47-14.22,24.48-21.33,42.03-21.33c17.27,0,28.92,6.83,34.96,20.49h0.42l14.25-69.08H1969z  M1864.34,506.25c0,9.15,2.12,16.47,6.35,21.95c4.65,5.97,11.34,8.95,20.08,8.95c11.44,0,20.7-6.07,27.78-18.21 c5.89-10.26,8.84-21.46,8.84-33.6c0-8.46-2.32-15.4-6.97-20.81c-4.93-5.83-11.62-8.74-20.08-8.74c-10.89,0-19.84,5.86-26.84,17.58 C1867.4,483.5,1864.34,494.46,1864.34,506.25z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  id: "path1022",
  className: "st0",
  d: "M0,765.27h765.27V0H0V765.27z M363.49,554.82h-71.93v-71.96h-94.9L163,554.82H89.54L266.32,180.6 h97.18L363.49,554.82z M638.26,554.82h-71.19v-71.96h-95.66l-33.7,71.96h-72.67L541.05,180.6h97.21L638.26,554.82z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  id: "path1024",
  className: "st0",
  d: "M567.07,414.78V280.88l-62.74,133.91H567.07z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  id: "path1026",
  className: "st0",
  d: "M291.57,414.78V280.88l-62.79,133.91H291.57z"
});

var SvgAa = function SvgAa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1969 765.27",
    style: {
      enableBackground: "new 0 0 1969 765.27"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "aa.svg";
export { ForwardRef as ReactComponent };